import styled from 'styled-components';

export const Mover = styled.div.withConfig({ displayName: '-Mover' })`
	position: absolute;
  top: 0px;
  left: calc(100% * ${props => props.current ? -props.current : 0});
  width: calc(100% * ${props => props.levels ?? props.children.length});
  height: 100%;
  display: flex;
  flex-direction: row;
  transition: all 0.15s ease-in-out;

  & > * {
    width: calc(100% / ${props => props.children.length});
  }
`;
